import React, { Component } from 'react';
import Obfuscate from 'react-obfuscate'
import Hero from '../modules/Hero/Hero';
import globals from '../globals';
import HelmetDefault from "../layout/HelmetDefault";
import Heading from "../elements/Heading";
import ResponsiveTable from "../elements/ResponsiveTable";
import TwinColumn from "../modules/TwinColumn";
import FiveColumn from "../modules/FiveColumn/FiveColumn";

class BulkSms extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            seoTitle: '',
            seoDescription: '',
            dataReceived: false,
			table: {data: {headings: [], rows: []}},
			twinColumn: {
            	list1: [],
				list2: []
			},
			fiveColumn: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

	componentWillUnmount() {
		globals.destroy(this.controller);
	}

    getData() {
        fetch('/api/voip/bulk-sms')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
				this.controller = globals.genericAnimation(this.content);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
    	const Email = <span className="bold">
			<Obfuscate
			email="corporatesms@exetel.com.au"
			headers={{
				subject: 'Bulk SMS - Enquiry'
			}}
		/></span>;
    	const Phone = <a href="tel:0280301040"><span className="bold">02 8030 1040</span></a>;
		const Heading1 = <h3>{this.state.twinColumn.heading1}</h3>;
		const Heading2 = <h3>{this.state.twinColumn.heading2}</h3>;
		const List1 = <ul>
			{this.state.twinColumn.list1.map((item, key) => {
				return <li key={key}>{item}</li>;
			})}
		</ul>;
		const List2 = <ul>
			{this.state.twinColumn.list2.map((item, key) => {
				return <li key={key}>{item}</li>;
			})}
		</ul>;

        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}} className="voip-bulk-sms">
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived}>
					<p>Use bulk SMS for:</p>
					<ul>
						<li>Marketing</li>
						<li>Customer Service</li>
						<li>Alerts and Reminders</li>
						<li>Contacting Roaming Employees</li>
						<li>Research</li>
					</ul>
					<p>SMS is such a powerful tool because it is a cost-effective and un-intrusive way of directly contacting people. If you would like to discuss further how this incredibly effective communication medium can be used by your business please contact {Email} or call {Phone}</p>
				</Hero>
                <section className="table-container">
					<div className="inner">
						<div className="row" ref={el => this.content = el}>
							<div className="col-md-8 col-md-offset-2 col-xs-12">
								<Heading title={this.state.table.title}>
									<p>{this.state.table.leadCopy}</p>
								</Heading>
								<ResponsiveTable data={this.state.table.data} />
							</div>
							<div className="col-md-6 col-md-offset-3 col-xs-12 centered terms-copy">
								<p>
									<small>{this.state.table.terms}</small>
								</p>
							</div>
						</div>
					</div>
					<div className="bottom-wave-darkgreen" />
				</section>
				<TwinColumn
					data={this.state.twinColumn}
					heading1={Heading1}
					heading2={Heading2}
					list1={List1}
					list2={List2}
				/>
				<FiveColumn data={this.state.fiveColumn} />
            </div>
        );
    }

}

export default BulkSms;


// WEBPACK FOOTER //
// ./resources/assets/js/voip/BulkSms.js